var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184876",
    "data-name": "Group 184876",
    transform: "translate(-282 -3676)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149942",
    "data-name": "Rectangle 149942",
    width: 26,
    height: 14,
    rx: 7,
    transform: "translate(282 3676)",
    fill: "#DAE1F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149943",
    "data-name": "Rectangle 149943",
    width: 10,
    height: 10,
    rx: 5,
    transform: "translate(284 3678)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActive);
export default __webpack_public_path__ + "static/media/inActive.13cc8365b72cc5f9fb8bdcc877ada8c9.svg";
export { ForwardRef as ReactComponent };